import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const BabyIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <g clipPath="url(#clip0_7604_52406)">
          <path
            d="M25.6225 11.1537C27.1945 17.0204 23.713 23.0506 17.8463 24.6225C11.9796 26.1945 5.94942 22.713 4.37745 16.8463C2.80548 10.9796 6.28703 4.94942 12.1537 3.37745C18.0204 1.80548 24.0506 5.28703 25.6225 11.1537Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.4581 23.1737C22.5245 21.8161 25.5312 16.6084 24.1737 11.5419C22.8161 6.47545 17.6084 3.46878 12.5419 4.82634C7.47545 6.1839 4.46878 11.3916 5.82634 16.4581C7.1839 21.5245 12.3916 24.5312 17.4581 23.1737ZM17.8463 24.6225C23.713 23.0506 27.1945 17.0204 25.6225 11.1537C24.0506 5.28703 18.0204 1.80548 12.1537 3.37745C6.28703 4.94942 2.80548 10.9796 4.37745 16.8463C5.94942 22.713 11.9796 26.1945 17.8463 24.6225Z"
            fill="#0F3893"
          />
          <path
            d="M2 17C2 18.1046 2.89543 19 4 19C4.74028 19 5.38663 18.5978 5.73244 18L4 15C2.89543 15 2 15.8954 2 17Z"
            fill="#C0AAFE"
          />
          <path
            d="M27.7344 11C27.7344 9.89543 26.8389 9 25.7344 9C24.9941 9 24.3477 9.4022 24.0019 10L25.7344 13C26.8389 13 27.7344 12.1046 27.7344 11Z"
            fill="#C0AAFE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5045 16.4448C19.8111 16.7233 19.8339 17.1977 19.5554 17.5043C18.7239 18.4197 17.6614 19.1217 16.4272 19.4851C15.192 19.8489 13.9417 19.8272 12.7877 19.4862C12.3904 19.3688 12.1636 18.9516 12.2809 18.5544C12.3983 18.1572 12.8155 17.9303 13.2127 18.0477C14.0973 18.3091 15.0528 18.3262 16.0034 18.0462C16.9549 17.766 17.7851 17.2223 18.445 16.4957C18.7235 16.1891 19.1979 16.1663 19.5045 16.4448Z"
            fill="#000083"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.7681 19.0918C25.687 13.8024 22.431 8.5919 17.1452 7.17557C12.2104 5.85328 7.15422 8.27956 5 12.7089C5.05393 12.3985 5.12224 12.0878 5.20535 11.7776C6.70481 6.18159 12.4568 2.86065 18.0529 4.3601C23.6489 5.85956 26.9699 11.6116 25.4704 17.2076C25.2932 17.8689 25.0567 18.4983 24.7681 19.0918Z"
            fill="#EDE8FF"
          />
          <path
            d="M13.5975 13.9115C13.8055 14.6877 13.3449 15.4855 12.5687 15.6935C11.7925 15.9015 10.9947 15.4409 10.7867 14.6647C10.5788 13.8885 11.0394 13.0907 11.8156 12.8827C12.5917 12.6747 13.3896 13.1353 13.5975 13.9115Z"
            fill="#0F3893"
          />
          <path
            d="M19.2186 12.4052C19.4266 13.1814 18.966 13.9792 18.1898 14.1872C17.4136 14.3951 16.6158 13.9345 16.4078 13.1583C16.1998 12.3822 16.6605 11.5843 17.4367 11.3764C18.2128 11.1684 19.0107 11.629 19.2186 12.4052Z"
            fill="#0F3893"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.4581 23.1737C22.5245 21.8161 25.5312 16.6084 24.1737 11.5419C22.8161 6.47545 17.6084 3.46878 12.5419 4.82634C7.47545 6.1839 4.46878 11.3916 5.82634 16.4581C7.1839 21.5245 12.3916 24.5312 17.4581 23.1737ZM17.8463 24.6225C23.713 23.0506 27.1945 17.0204 25.6225 11.1537C24.0506 5.28703 18.0204 1.80548 12.1537 3.37745C6.28703 4.94942 2.80548 10.9796 4.37745 16.8463C5.94942 22.713 11.9796 26.1945 17.8463 24.6225Z"
            fill="#0F3893"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.25 4C12.25 3.58579 12.5858 3.25 13 3.25C13.7867 3.25 14.95 3.47984 15.9382 4.19135C16.9647 4.9304 17.75 6.15556 17.75 8C17.75 8.41421 17.4142 8.75 17 8.75C16.5858 8.75 16.25 8.41421 16.25 8C16.25 6.64444 15.702 5.8696 15.0618 5.40865C14.3833 4.92016 13.5466 4.75 13 4.75C12.5858 4.75 12.25 4.41421 12.25 4Z"
            fill="#0F3893"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.25 6C8.25 5.58579 8.58579 5.25 9 5.25C9.78668 5.25 10.95 5.47984 11.9382 6.19135C12.9647 6.9304 13.75 8.15556 13.75 10C13.75 10.4142 13.4142 10.75 13 10.75C12.5858 10.75 12.25 10.4142 12.25 10C12.25 8.64444 11.702 7.8696 11.0618 7.40865C10.3833 6.92016 9.54665 6.75 9 6.75C8.58579 6.75 8.25 6.41421 8.25 6Z"
            fill="#0F3893"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.25 5C10.25 4.58579 10.5858 4.25 11 4.25C11.7867 4.25 12.95 4.47984 13.9382 5.19135C14.9647 5.9304 15.75 7.15556 15.75 9C15.75 9.41421 15.4142 9.75 15 9.75C14.5858 9.75 14.25 9.41421 14.25 9C14.25 7.64444 13.702 6.8696 13.0618 6.40865C12.3833 5.92016 11.5466 5.75 11 5.75C10.5858 5.75 10.25 5.41421 10.25 5Z"
            fill="#0F3893"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9998 9.75C25.6266 9.75 25.2923 9.91264 25.0621 10.1734L23.9375 9.18079C24.4403 8.61112 25.1783 8.25 25.9998 8.25C27.5186 8.25 28.7498 9.48122 28.7498 11C28.7498 12.5188 27.5186 13.75 25.9998 13.75C25.5002 13.75 25.0295 13.6161 24.6243 13.3816L25.3753 12.0832C25.5584 12.1891 25.7709 12.25 25.9998 12.25C26.6902 12.25 27.2498 11.6904 27.2498 11C27.2498 10.3096 26.6902 9.75 25.9998 9.75Z"
            fill="#0F3893"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 15.75C3.30964 15.75 2.75 16.3096 2.75 17C2.75 17.6904 3.30964 18.25 4 18.25C4.37324 18.25 4.70755 18.0874 4.9377 17.8266L6.0623 18.8192C5.5595 19.3889 4.82146 19.75 4 19.75C2.48122 19.75 1.25 18.5188 1.25 17C1.25 15.4812 2.48122 14.25 4 14.25C4.34975 14.25 4.68595 14.3157 4.99569 14.436L4.45245 15.8342C4.31314 15.7801 4.16097 15.75 4 15.75Z"
            fill="#0F3893"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.8811 24.6333C17.2597 25.7095 17.6285 27.0855 18.7046 27.7069C19.7808 28.3282 21.1569 27.9595 21.7782 26.8833L23.0772 27.6333C22.0417 29.4269 19.7482 30.0414 17.9546 29.0059C16.161 27.9704 15.5465 25.6769 16.582 23.8833L17.8811 24.6333Z"
            fill="#0F3893"
          />
          <path
            d="M27.7954 19.9641C26.6908 21.8773 24.2445 22.5328 22.3313 21.4282C20.4181 20.3236 19.7626 17.8773 20.8672 15.9641C21.9718 14.0509 24.4181 13.3954 26.3313 14.5C28.2445 15.6046 28.9 18.0509 27.7954 19.9641Z"
            fill="#006DFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.0813 20.1292C24.277 20.8195 25.806 20.4098 26.4964 19.2141C27.1867 18.0184 26.777 16.4894 25.5813 15.799C24.3856 15.1087 22.8566 15.5184 22.1662 16.7141C21.4759 17.9098 21.8856 19.4388 23.0813 20.1292ZM22.3313 21.4282C24.2445 22.5328 26.6908 21.8773 27.7954 19.9641C28.9 18.0509 28.2445 15.6046 26.3313 14.5C24.4181 13.3954 21.9718 14.0509 20.8672 15.9641C19.7626 17.8773 20.4181 20.3236 22.3313 21.4282Z"
            fill="#0F3893"
          />
          <path
            d="M16 22.3922C16.5523 21.4356 17.7755 21.1079 18.7321 21.6602L23.9282 24.6602C24.8848 25.2124 25.2125 26.4356 24.6603 27.3922C24.108 28.3488 22.8848 28.6765 21.9282 28.1243L16.7321 25.1243C15.7755 24.572 15.4477 23.3488 16 22.3922Z"
            fill="#E4E0FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.1782 25.9592L17.9821 22.9592C17.7429 22.8211 17.4371 22.9031 17.299 23.1422C17.161 23.3814 17.2429 23.6871 17.4821 23.8252L22.6782 26.8252C22.9173 26.9633 23.2231 26.8814 23.3612 26.6422C23.4993 26.4031 23.4173 26.0973 23.1782 25.9592ZM18.7321 21.6602C17.7755 21.1079 16.5523 21.4356 16 22.3922C15.4477 23.3488 15.7755 24.572 16.7321 25.1243L21.9282 28.1243C22.8848 28.6765 24.108 28.3488 24.6603 27.3922C25.2125 26.4356 24.8848 25.2124 23.9282 24.6602L18.7321 21.6602Z"
            fill="#0F3893"
          />
          <path
            d="M21.0977 19.5623L24.5618 21.5623L22.5618 25.0264L19.0977 23.0264L21.0977 19.5623Z"
            fill="#9E74FD"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.5127 22.1113L21.6467 21.6113L21.1467 22.4773L22.0127 22.9773L22.5127 22.1113ZM21.0977 19.5623L19.0977 23.0264L22.5618 25.0264L24.5618 21.5623L21.0977 19.5623Z"
            fill="#0F3893"
          />
          <path
            d="M12 27C12 27.5523 11.5523 28 11 28C10.4477 28 10 27.5523 10 27C10 26.4477 10.4477 26 11 26C11.5523 26 12 26.4477 12 27Z"
            fill="#006DFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.53033 23.9698C7.82322 24.2627 7.82322 24.7376 7.53033 25.0304L6.37648 26.1843C6.08359 26.4772 5.60872 26.4772 5.31582 26.1843C5.02293 25.8914 5.02293 25.4165 5.31582 25.1236L6.46967 23.9698C6.76256 23.6769 7.23744 23.6769 7.53033 23.9698Z"
            fill="#006DFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.68267 27.816C3.97557 28.1089 3.97557 28.5837 3.68267 28.8766L2.52883 30.0305C2.23593 30.3234 1.76106 30.3234 1.46817 30.0305C1.17527 29.7376 1.17527 29.2627 1.46817 28.9698L2.62201 27.816C2.91491 27.5231 3.38978 27.5231 3.68267 27.816Z"
            fill="#006DFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.46783 23.9697C1.76072 23.6768 2.2356 23.6768 2.52849 23.9697L3.68234 25.1235C3.97523 25.4164 3.97523 25.8913 3.68234 26.1842C3.38944 26.4771 2.91457 26.4771 2.62168 26.1842L1.46783 25.0303C1.17494 24.7374 1.17494 24.2626 1.46783 23.9697Z"
            fill="#006DFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.31549 27.8159C5.60838 27.523 6.08325 27.523 6.37615 27.8159L7.52999 28.9697C7.82289 29.2626 7.82289 29.7375 7.52999 30.0304C7.2371 30.3233 6.76223 30.3233 6.46933 30.0304L5.31549 28.8765C5.02259 28.5836 5.02259 28.1088 5.31549 27.8159Z"
            fill="#006DFF"
          />
        </g>
        <defs>
          <clipPath id="clip0_7604_52406">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);
export default BabyIcon;
